import React from "react";

export default function Banner({
  children,
  className = "",
  leftImage,
  rightImage,
}) {
  return (
    <section
      className={`bg-vertical-red-purple bg-cover-image ${className} banner position-relative d-flex align-items-center`}
    >
      {leftImage && (
        <div
          className="banner-left-image position-absolute top-0 start-0 w-100 h-100"
          style={{
            backgroundImage: `url(${leftImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center left",
            backgroundRepeat: "no-repeat",
          }}
        />
      )}

      {rightImage && (
        <div
          className="banner-right-image position-absolute top-0 start-0 w-100 h-100 d-none d-lg-block"
          style={{
            backgroundImage: `url(${rightImage})`,
            backgroundSize: "auto 100%",
            backgroundPositionX: "calc(100% + max(0px, 1750px - 100vw))",
            backgroundPositionY: "center",
            backgroundRepeat: "no-repeat",
          }}
        />
      )}

      <div className="container position-relative">
        <div className="row align-items-center justify-content-between">
          {children}
        </div>
      </div>
    </section>
  );
}
